import React, { useRef } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { MenuMaster } from 'models/role';

import {
    WorkflowMenuMasterForm,
    WorkflowMenuMasterFormRefHandle
} from './WorkflowMenuMasterForm';

export type WorkflowMenuMasterFormModal = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    disabledKeyField?: boolean;
    defaultValues?: MenuMaster[];
    onSubmit?: (menuMasters: MenuMaster[]) => void;
};

export const WorkflowMenuMasterFormModal = (
    props: WorkflowMenuMasterFormModal
) => {
    const {
        disabledKeyField,
        title,
        isOpen,
        onClose,
        defaultValues,
        onSubmit
    } = props;

    const formRef = useRef<WorkflowMenuMasterFormRefHandle>(null);

    const handleSaveClick = () => {
        const menuMasters = formRef.current?.submit();
        if (!menuMasters) {
            return;
        }

        onSubmit?.(menuMasters);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                <WorkflowMenuMasterForm
                    ref={formRef}
                    disabledKeyField={disabledKeyField}
                    defaultValues={defaultValues}
                />
            </ModalBody>
            <ModalFooter className="flex justify-end">
                <Button
                    color="primary"
                    onClick={handleSaveClick}
                >
                    Save
                </Button>
                <Button
                    color="secondary"
                    onClick={onClose}
                    className="border-none bg-neutral-600"
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};
